import * as React from 'react';
import styled from 'styled-components';
import { Tooltip, TooltipTrigger } from '../Tooltips/TooltipStyles';

export type BaseProps = {
  children?: any;
  tooltip?: string;
  tooltipId?: string;
}

export interface IconProps extends Omit<React.AriaAttributes, 'className' | 'color' | 'size' | 'label'> {
  label?: string;
  className?: string;
  color?: string;
  size?: string;
  viewBox?: string;
};

/**
 * Retrieves the size of the icon.
 * @param size - Original size which was passed to the icon.
 * @returns Numeric value indicating the size of the icon.
 */
export const getSize = (size: string) => {
  if (typeof size === 'string' && size.indexOf('px') === -1) {
    return `${size}px`;
  } else {
    return size;
  }
};

const Container = styled.div`
  position: relative;
  ${TooltipTrigger('hover')}
`;

const renderIcon = (children: React.ReactNode, tooltip?: string, tooltipId?: string) => {
  return tooltip ? (
    <Container>
      {children}
      <Tooltip id={tooltipId}>{tooltip}</Tooltip>
    </Container>
  ) : (
    <>
      {children}
    </>
  );
}

const gTagsRegex = new RegExp(/<g [A-Za-z\W\D]*>/,'g'); // matches <g id = ".....">
const fillColorRegex = new RegExp(/fill="#[A-F0-9]*"/,'g'); // matches fill="#1F1F1F"

export const formatSvgString = (text: string, color: string): string => {
  return text.replace(gTagsRegex, '')
             .replaceAll('</g>','')
             .replace(fillColorRegex, `fill="${color}"`);
}

export const SystemIcon: React.FunctionComponent<BaseProps> = ({ children, tooltip = '', tooltipId = '' }) => {
  return renderIcon(children, tooltip, tooltipId);
};

export const ContentIcon: React.FunctionComponent<BaseProps> = ({ children, tooltip = '', tooltipId = '' }) => {
  return renderIcon(children, tooltip, tooltipId);
};

export * as ContentIcons  from './contenticons';
export * as SystemIcons from './systemicons';
